import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const target = location.pathname + location.search;
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        toast.success(`Welcome, ${data.name.split(" ")[0]}`);
      })
      .catch(() => toast.error("Sign-in failed, please try again"))
      .finally(() => navigate(target, { replace: true }));
  }, [location, navigate, setUser]);

  return null;
}
